import React, { Suspense } from 'react';
import { Container, Typography } from '@material-ui/core';
import zIndex from '@material-ui/core/styles/zIndex';

import { LoadingPanel, Icon, BackdropPanel } from '..';
import { MuiBackdropButton } from '../BackdropPanel/style';
import { TranslationJSX } from '../../utils/Translation';

interface Props {
    isOpen: boolean;
    locoKey: 'feed_server_connection_failed_error_msg' | 'feed_server_unknown_error_msg';
    onClick: () => void;
}

const GlobalErrorPanelView = ({ isOpen, locoKey, onClick }: Props) => (
    <Suspense fallback={<LoadingPanel isOpen backdropInvisible />}>
        <BackdropPanel isOpen={isOpen} style={{ zIndex: zIndex.snackbar }}>
            <Container maxWidth="xs" style={{ textAlign: 'center' }}>
                <Icon name="errorLocal" size={80} />
                <Typography variant="body2">
                    <TranslationJSX locoKey={locoKey} />
                </Typography>
                <MuiBackdropButton onClick={onClick}>
                    <TranslationJSX locoKey="button_ok" />
                </MuiBackdropButton>
            </Container>
        </BackdropPanel>
    </Suspense>
);

export default GlobalErrorPanelView;
